/**
 * Create a component with common options
 */
import createBasic from './create-basic';
import Icon from '../icon';
import Loader from '../loader';
import Cell from '../cell';
import CellGroup from '../cell-group';

export default function(sfc) {
  sfc.components = Object.assign(sfc.components || {}, {
    Icon,
    Loader,
    Cell,
    CellGroup
  });
  return createBasic(sfc);
};



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/utils/create.js